export default __webpack_public_path__ + "static/media/D_wdt_c_cap_2.268ee5ab.mp3";